import RevStatsSearchLinkTag from '../components/Navigation/RevStatsSearchLinkTag';

export default function getTagCharacterForRevStatsSearchLink(category) {
    switch (category) {
        case 'customer':
            return RevStatsSearchLinkTag.CUSTOMER;
        case 'product':
            return RevStatsSearchLinkTag.PRODUCT;
        default:
            return '';
    }
}
